
export default class ApiHelper {
    static appSettings;  
}

export const API_ACTION_LOGIN = "User/Login";
export const API_ACTION_GETSQLFILES = "File/GetSQLFiles";
export const API_ACTION_EXECUTESQLSCRIPTS = "File/ExecuteSQLFiles";


export const ComposeUri = (action) => {
    return ApiHelper.appSettings.SQLUPDATETOOL_API_BASE_URL + action;
}


